module.exports = __webpack_public_path__ + "img/button_icon_refresh.c546a7a.svg";